export const InternalLoadType = {
    DirectToSplatBuffer: 0,
    DirectToSplatArray: 1,
    DownloadBeforeProcessing: 2
};
